import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Close = createSvgIcon(React.createElement("polygon", { points: "20,5.4 18.6,4 12,10.6 5.4,4 4,5.4 10.6,12 4,18.6 5.4,20 12,13.4 18.6,20 20,18.6 13.4,12" }), 'Close');
export default Close;
